<template>
  <component :is="iconComponent" />
</template>

<script>
import IconHeartOutline80px from "@/common/components/icons/IconHeartOutline80px.vue";
import IconHeartOutline56px from "@/common/components/icons/IconHeartOutline56px.vue";

export default {
  components: {
    IconHeartOutline80px,
    IconHeartOutline56px
  },

  props: {
    iconSize: {
      type: Number,
      default: 80
    }
  },

  computed: {
    iconComponent() {
      const { iconSize } = this;
      return `IconHeartOutline${iconSize}px`;
    }
  }
};
</script>
